import { SmbContainer } from '../Smb';

export const PagesContainer: React.FC = () => {
  return <SmbContainer />;
};
